var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoBackArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3475_5671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 26,
    height: 26,
    transform: "rotate(-180 26 26)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3475_5671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1937 7.4626C10.5168 7.13948 11.0419 7.14326 11.3603 7.47099C11.6723 7.79212 11.6686 8.3043 11.352 8.62091L7.7854 12.1875L20.5313 12.1875C20.98 12.1875 21.3438 12.5513 21.3438 13C21.3438 13.4487 20.98 13.8125 20.5313 13.8125L7.7854 13.8125L11.352 17.3791C11.6686 17.6957 11.6723 18.2079 11.3603 18.5291C11.0419 18.8568 10.5168 18.8606 10.1937 18.5374L5.3129 13.6566C4.95027 13.294 4.95027 12.7061 5.3129 12.3434L10.1937 7.4626Z",
    fill: "#0F6656",
    stroke: "#0F6656",
    strokeWidth: 0.464286
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackArrow);
export default __webpack_public_path__ + "static/media/GoBackArrow.9fbcef89724599a8528e5389bb92232e.svg";
export { ForwardRef as ReactComponent };